import React from 'react';
import { translate } from 'react-i18next';

import * as Common from 'common/components';
import CustomFieldsEmployeesList from './list';

const CustomFieldsEmployeesListView = ({
  children,
  count = 0,
  filters = {},
  isLoading = false,
  company = {},
  pagination = {},
  permissions = {},
  subcompany = {},
  handleToggle = () => {},
  handleOrderChange = () => {},
  handleFiltersChange = () => {},
  handleLimitChange = () => {},
  handlePageChange = () => {},
  handleSubmit = () => {},
  columnSearch,
  handleToggleSearch = () => {}, // Agregar
  t,
}) => {
  return (
    <Common.Wrapper fluid={true}>
      <CustomFieldsEmployeesList.Header
        companyId={company.id}
        subcompanyId={subcompany.id}
        canAdd={permissions['acl.custom_employee.add']}
      />
      <div className="col-12">
        <Common.Portlet title={t('custom_fields_employees.title')} icon={'users'}>
          <CustomFieldsEmployeesList.Filters
            handleSubmit={handleSubmit}
            handleToggleSearch={handleToggleSearch} // Agregar
            columnSearch={columnSearch} // Agregar
            handleValueChange={handleFiltersChange}
            values={filters}
          />
          <div className="mb-2" style={{ position: 'relative' }}>
            <CustomFieldsEmployeesList.Table
              company={company}
              subcompany={subcompany}
              permissions={permissions}
              handleToggle={handleToggle}
              count={count}
              handleOrderChange={handleOrderChange}
              order={pagination.order}
              orderBy={pagination.orderBy}
            >
              {children}
            </CustomFieldsEmployeesList.Table>
            <Common.LoaderOverlay show={isLoading} />
          </div>
          <Common.Pagination
            {...pagination}
            handleLimitChange={handleLimitChange}
            handlePageChange={handlePageChange}
          />
        </Common.Portlet>
      </div>
    </Common.Wrapper>
  );
};

export default translate()(CustomFieldsEmployeesListView);



// WEBPACK FOOTER //
// src/modules/secured/modules/custom_fields_employees/components/EmployeesListView.js